import "./Navbar.scss";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";
import {useUserStore} from "../../../../../modules/shop/user/store";
import {PATHS_API} from "../../../../../enum";
import {PATHS} from "../../../../routers/utils/Paths.links";
import {CHILD_PROFILE_PATHS} from "../../../ProfilePage/components/Sidebar/Sidebar";
import DepositWallet from "../../../../shared/UIComponents/DepositWallet/DepositWallet";
import BurgerButton from "./components/BurgerButton/BurgerButton";
import {useI18n} from "../../../../i18n/I18nProvider";
import {NAV_ITEMS} from "./navItems";
import {useIsAdmin} from "../../../../hooks/useIsAdmin";

const Navbar = () => {
    const { t } = useI18n()
    const user = useUserStore(state => state.user)
    const fetchUser = useUserStore(state => state.fetchUser)
    const location = useLocation();
    // кнопку бачить лише адмін; доступ до самої адмінки все одно перевіряє сервер
    const isAdmin = useIsAdmin(!!user?._id);

    // червоний лічильник на кнопці адмінки: нерозібрані попередження й не зараховані платежі
    const [adminIssues, setAdminIssues] = useState(0);
    useEffect(() => {
        if (!isAdmin) return;
        // без введеного PIN сервер не відповідає — тоді лічильник просто не показуємо
        const load = () => axios.get(`${PATHS_API.ADMIN_ALERTS}/count`, { withCredentials: true })
            .then(({ data }) => setAdminIssues(Number(data.total) || 0))
            .catch(() => setAdminIssues(0));
        load();
        const timer = window.setInterval(load, 60_000);
        return () => window.clearInterval(timer);
    }, [isAdmin, location.pathname]);

    useEffect(() => {
        fetchUser()
    }, [])

    return (
        <div className="wrapper-fake">
            <div className="wrapper">
                <nav className="navbar">
                    <Link className="navbar-brand" to={PATHS.SHOP}>
                        <h4 className="navbar-logo">ASKOLD</h4>
                    </Link>
                    <div className="navbar-links">
                        { NAV_ITEMS.map((item) => {
                            const active = item.isActive(location.pathname);
                            return (
                                <Link
                                    key={item.key}
                                    className={`navbar-stats ${active ? "navbar-stats-active" : ""}`}
                                    to={item.to}
                                    title={t(item.labelKey)}
                                    aria-current={active ? "page" : undefined}
                                >
                                    {item.icon}
                                    <span className="navbar-stats-text">{t(item.labelKey)}</span>
                                </Link>
                            );
                        })}
                    </div>
                    {/* права частина: гравець (баланс і профіль) або вхід; меню на мобільних */}
                    <div className="navbar-right">
                        { user?._id
                            ? <>
                                { isAdmin &&
                                    <Link
                                        className={`navbar-admin ${location.pathname.startsWith(PATHS.ADMIN) ? "navbar-admin-active" : ""}`}
                                        to={PATHS.ADMIN}
                                        title={adminIssues ? `Адмінка: ${adminIssues} потребує уваги` : "Адмінка"}
                                        aria-label={adminIssues ? `Адмінка, ${adminIssues} потребує уваги` : "Адмінка"}
                                    >
                                        {/* шестерня обертається при наведенні */}
                                        <svg className="navbar-admin-gear" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M10.3 2.6a1.7 1.7 0 013.4 0l.2 1a1.7 1.7 0 002.4 1l.9-.5a1.7 1.7 0 012.4 2.4l-.5.9a1.7 1.7 0 001 2.4l1 .2a1.7 1.7 0 010 3.4l-1 .2a1.7 1.7 0 00-1 2.4l.5.9a1.7 1.7 0 01-2.4 2.4l-.9-.5a1.7 1.7 0 00-2.4 1l-.2 1a1.7 1.7 0 01-3.4 0l-.2-1a1.7 1.7 0 00-2.4-1l-.9.5a1.7 1.7 0 01-2.4-2.4l.5-.9a1.7 1.7 0 00-1-2.4l-1-.2a1.7 1.7 0 010-3.4l1-.2a1.7 1.7 0 001-2.4l-.5-.9a1.7 1.7 0 012.4-2.4l.9.5a1.7 1.7 0 002.4-1z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                        { adminIssues > 0 && <span className="navbar-admin-badge">{adminIssues > 99 ? "99+" : adminIssues}</span> }
                                    </Link>
                                }
                                <DepositWallet user={user} />
                                <Link
                                    className="navbar-user"
                                    to={PATHS.PROFILE + CHILD_PROFILE_PATHS.BASKET}
                                    title={t("nav.profile")}
                                >
                                    { user.avatarUrl
                                        ? <img className="navbar-user-avatar" src={user.avatarUrl} alt="" />
                                        : <span className="navbar-user-avatar navbar-user-empty">{user.personaName?.[0]?.toUpperCase() ?? "?"}</span>
                                    }
                                    <span className="navbar-user-name">{user.personaName}</span>
                                </Link>
                            </>
                            : <a className="navbar-login" href={PATHS_API.LOGIN}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M12 2a10 10 0 00-9.96 9.2l5.36 2.21a2.83 2.83 0 011.6-.49l2.39-3.46v-.05a3.78 3.78 0 113.78 3.78h-.09l-3.4 2.43a2.84 2.84 0 01-5.62.56L2.3 14.6A10 10 0 1012 2zm-4.4 15.2l-1.23-.5a2.13 2.13 0 103.9-1.64 2.12 2.12 0 00-2.67-1.17l1.27.53a1.57 1.57 0 11-1.27 2.78zm9.92-7.13a2.52 2.52 0 10-2.52 2.52 2.52 2.52 0 002.52-2.52zm-4.4 0a1.89 1.89 0 111.89 1.89 1.89 1.89 0 01-1.9-1.89z" />
                                </svg>
                                <span>{t("nav.login")}</span>
                            </a>
                        }
                        <BurgerButton />
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Navbar;